import React from 'react';
import { motion } from 'framer-motion';
import { FiGrid, FiBarChart, FiSettings, FiZap, FiArrowLeft, FiHome } from 'react-icons/fi';
import { subjects } from '../data/flashcards';
import './Header.css';

const Header = ({ currentView, setCurrentView, stats, selectedSubject, onBackToSubjects }) => {
  const navItems = [
    { id: 'subjects', label: 'Subjects', icon: FiHome },
    { id: 'deck', label: 'Cards', icon: FiGrid },
    { id: 'stats', label: 'Stats', icon: FiBarChart },
    { id: 'settings', label: 'Settings', icon: FiSettings }
  ];

  const getCurrentSubjectInfo = () => {
    if (selectedSubject === 'all') {
      return { name: 'All Subjects', icon: '📚', color: '#667eea' };
    }
    return subjects.find(s => s.key === selectedSubject) || { name: 'Unknown', icon: '❓', color: '#666' };
  };

  const subjectInfo = getCurrentSubjectInfo();

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <motion.div 
            className="logo"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setCurrentView('subjects')}
            style={{ cursor: 'pointer' }}
          >
            <div className="logo-icon">
              <FiZap />
            </div>
            <div className="logo-text">
              <h1>WhatsThis</h1>
              <span>.today</span>
            </div>
          </motion.div>

          {currentView === 'deck' && selectedSubject && (
            <motion.div 
              className="current-subject"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
            >
              <motion.button
                className="back-btn"
                onClick={onBackToSubjects}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FiArrowLeft />
              </motion.button>
              <div className="subject-info">
                <span 
                  className="subject-icon" 
                  style={{ color: subjectInfo.color }}
                >
                  {subjectInfo.icon}
                </span>
                <span className="subject-name">{subjectInfo.name}</span>
              </div>
            </motion.div>
          )}
        </div>

        <nav className="nav">
          {navItems.map((item) => {
            // Hide subjects nav item when already on subjects view
            if (item.id === 'subjects' && currentView === 'subjects') return null;
            // Hide deck nav item when no subject is selected
            if (item.id === 'deck' && !selectedSubject) return null;
            
            const Icon = item.icon;
            if (!Icon) {
              console.error('Icon not found for:', item.label);
              return null;
            }
            return (
              <motion.button
                key={item.id}
                className={`nav-item ${currentView === item.id ? 'active' : ''}`}
                onClick={() => setCurrentView(item.id)}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
              >
                <Icon className="nav-icon" />
                <span className="nav-label">{item.label}</span>
                {currentView === item.id && (
                  <motion.div 
                    className="nav-indicator"
                    layoutId="nav-indicator"
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                  />
                )}
              </motion.button>
            );
          })}
        </nav>

        <div className="header-right">
          <div className="streak-display">
            <FiZap className="streak-icon" />
            <span className="streak-number">{stats.streak}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 